import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import FormGrid from '../../Form/FormGrid/FormGrid';
import Button from '../../Buttons/Button/Button';
import { stringSchema } from '../../../services/schemas';
import LabelFieldFormik from '../../Fields/LabelField/LabelFieldFormik';

import classes from './Confirm.module.scss';

const valuesForConfirm = {
  confirmValue: ''
};

const messageFormik = 'Campo obligatorio';

const validationSchemaState = Yup.object().shape({ confirmValue: stringSchema(messageFormik) });

const typeConfirmationContent = {
  question: {
    label: '¿Cuál es el nombre de tu primera mascota?',
    subtitle: 'Responde una pregunta de seguridad',
    description: 'Queremos asegurarnos que eres tu.'
  },
  code: {
    label: 'Código',
    subtitle: 'Te enviamos un código',
    description: 'Ingresa el código de N dígitos que te enviamos a tu celular terminado en ***4566'
  }
};

const Confirm = ({ typeConfirmation, changeConfirmLogin }) => {
  const fields = [{ key: 'confirmValue', label: typeConfirmationContent[typeConfirmation].label }];

  const confirmValueForPay = () => {
    changeConfirmLogin(step => step + 1);
  };

  return (
    <Formik initialValues={valuesForConfirm} validationSchema={validationSchemaState} onSubmit={confirmValueForPay}>
      {({ setFieldValue, isSubmitting }) => (
        <Form>
          <FormGrid
            className={classes.form}
            subtitle={typeConfirmationContent[typeConfirmation].subtitle}
            description={typeConfirmationContent[typeConfirmation].description}
            onChange={setFieldValue}
            fields={fields}
            Render={LabelFieldFormik}
          />

          <div className={classes.button}>
            <Button type='submit' disabled={isSubmitting}>
              Ingresar
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Confirm;
